import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import ProductCard from "../components/ProductCard";
import Cart from "../components/Cart";
import useWindowSize from "../utils";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        overflowX: "hidden",
        overflowY: "hidden",
    },
    carrello: {
        marginTop: "2%",
        height: "100%",
        width: "100%",
        minHeight: "700px",
        height: "100%",
        borderLeft: "3px solid black",
        position: "relative",
    },
    carrelloMobile: {
        marginTop: "2%",
        height: "100%",
        width: "100%",
        borderLeft: "3px solid black",
        position: "relative",
    },
    products: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "750px",
        flexDirection: "column",
    },
    productsMobile: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "750px",
        flexDirection: "column",
    }
}));

const olioDesc = "olio fatto bene"
const bergamottoDesc = "bergamotto di qualità"

function Products() {
    const classes = useStyles();
    const [desc, setDesc] = useState("")
    const [cart, setCart] = useState({})
    const { width } = useWindowSize();

    const handleDesc = (val) => {
        switch (val) {
            case "Olio":
                return setDesc(olioDesc);
            case "Bergamotto":
                return setDesc(bergamottoDesc);
            default:
                return setDesc("");
        }
    }

    const addInCart = (val, quantity) => {
        const price = val === "Olio" ? 6.5 : 1.1
        setCart({
            ...cart, [val]: {
                quantity: quantity,
                price: price
            }
        })
    }

    const removeElement = (elm) => {
        setCart(Object.keys(cart).filter(itm => itm !== elm).reduce((obj, key) => {
            obj[key] = cart[key]
            return obj
        }, {}))
    }
    const resetCart = () => {
        setCart({})
        setDesc("")
    }

    return (
        <div className={classes.root}>
            {width < 550 && (
                <Grid container spacing={5} >
                    <Grid item xs={12} className={classes.carrelloMobile}>
                        <Cart cart={cart} removeEl={removeElement} resetCart={resetCart} />
                    </Grid>

                    <Grid item xs={12} className={classes.productsMobile} >
                        <ProductCard value="Bergamotto" desc={desc} handle={handleDesc} addInCart={addInCart} />
                        <ProductCard value="Olio" desc={desc} handle={handleDesc} addInCart={addInCart} />
                    </Grid>
                </Grid>
            )}
            {width >= 550 && (
                <Grid container spacing={5}>
                    <Grid item xs={9} className={classes.products} >
                        <div style={{ display: "flex", width: "90%", }}>
                            <ProductCard value="Bergamotto" desc={desc} handle={handleDesc} addInCart={addInCart} />
                            <ProductCard value="Olio" desc={desc} handle={handleDesc} addInCart={addInCart} />
                        </div>
                    </Grid>
                    <Grid item xs={3} className={classes.carrello}>
                        <Cart cart={cart} removeEl={removeElement} resetCart={resetCart} />
                    </Grid>
                </Grid>
            )}
        </div>
    );
}

export default Products;